import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaPhone, FaMapMarkerAlt, FaEnvelope, FaFileAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const TopBar = () => {
  const { t } = useLanguage();

  return (
    <div style={styles.topBar} className="topbar-compact">
      <div style={styles.container}>
        {/* Contact Info */}
        <div style={styles.leftSection}>
          <a href="tel:+21671232433" style={styles.contactItem} dir="ltr">
            <FaPhone style={styles.icon} />
            <span style={{ unicodeBidi: 'embed' }}>+216 71 232 433</span>
          </a>
          <a href="mailto:contact@ligue-amateur-n2.tn" style={styles.contactItem} dir="ltr">
            <FaEnvelope style={styles.icon} />
            <span style={{ unicodeBidi: 'embed' }}>contact@ligue-amateur-n2.tn</span>
          </a>
          <span style={styles.contactItem}>
            <FaMapMarkerAlt style={styles.icon} />
            <span>{t('tunis')}</span>
          </span>
        </div>

        {/* Right Section - Social & Links */}
        <div style={styles.rightSection}>
          <a href="/communiques" style={styles.communiqueLink}>
            <FaFileAlt style={styles.icon} />
            <span>{t('communiques')}</span>
          </a>
          
          <div style={styles.socialLinks}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon}>
              <FaFacebook />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon}>
              <FaTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon}>
              <FaInstagram />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon}>
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  topBar: {
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    color: 'white',
    padding: '8px 0',
    fontSize: 'clamp(11px, 2.5vw, 13px)',
    borderBottom: '2px solid #c41e3a',
    width: '100%',
    maxWidth: '100vw',
    boxSizing: 'border-box'
  },
  container: {
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '8px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    boxSizing: 'border-box'
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    minWidth: 0
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    minWidth: 0
  },
  contactItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: 'white',
    textDecoration: 'none',
    transition: 'color 0.3s',
    whiteSpace: 'nowrap',
    fontSize: 'inherit',
    outline: 'none',
    border: 'none'
  },
  communiqueLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    color: 'white',
    textDecoration: 'none',
    padding: '6px 12px',
    background: '#c41e3a',
    borderRadius: '5px',
    fontWeight: '600',
    transition: 'all 0.3s',
    whiteSpace: 'nowrap',
    letterSpacing: '0',
    fontSize: 'inherit',
    border: 'none',
    outline: 'none'
  },
  icon: {
    fontSize: '14px',
    flexShrink: 0
  },
  socialLinks: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    paddingLeft: '12px',
    borderLeft: '1px solid rgba(255,255,255,0.2)',
    flexWrap: 'wrap'
  },
  socialIcon: {
    color: 'white',
    fontSize: 'clamp(16px, 4vw, 18px)',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    minWidth: '28px',
    minHeight: '28px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.1)',
    flexShrink: 0,
    outline: 'none',
    border: 'none'
  }
};

export default TopBar;
